









































import * as _ from 'lodash';
import $ from 'jquery';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Draggable } from 'draggable-vue-directive';
import { Guid } from 'guid-typescript';

import { mixins } from 'vue-class-component';
import { Language, VisitorType } from '../../types/Enum';
import { IPortfolioWindowReduced, IVueWindow, ShortCutIcon } from '../../types/Interface';

import Shortcut from './Shortcut.vue';
import {
  Skills, AboutMe, Expertise, Experiences, Degree,
} from './windowContent';
import APortfolioWindow from './APortfolioWindow';


@Component({
  components: {
    Skills,
    AboutMe,
    Expertise,
    Experiences,
    Degree,
  },
  directives: {
    Draggable,
  },
})
export default class Window extends mixins(APortfolioWindow) {
  @Prop({ default: 'Explorateur de fichiers' }) readonly title!: string;

  @Prop({ default: () => Guid.create() }) readonly id!: Guid;

  /* public visible: boolean = true;

  public handleId:string = 'handle-id';

  public draggableValue: any = {
    handle: undefined,
  };

  private instance: IPortfolioWindowReduced = { id: this.id.toString(), instance: this as any }; */

  private check: Function = (str: string) => (this.title === str)

  /* public focusWindow() {
    console.log('Emit focus from normal windows');
    this.$emit('Window::Focus::Get', this.instance);
  }

  public addFocus() {
    const element: Element = (this.$refs.windowcontent as Element);
    if (_.isNil(element)) {
      throw new Error('Element introuvable');
    }
    $(element).addClass('focus-on');
  }

  public removeFocus() {
    const element: Element = (this.$refs.windowcontent as Element);
    if (_.isNil(element)) {
      throw new Error('Element introuvable');
    }
    $(element).removeClass('focus-on');
  } */

  public mounted() {
    // console.log(`constructeur windows ${this.id.toString()}`);
    this.visible = true;
    this.draggableValue.handle = this.$refs[this.handleId];
  }

  /* public redirect(link: string): void {
    switch (link) {
      case 'linkedin':
        window.open('https://www.linkedin.com/in/jean-david-nelson/', '_blank');
        break;
      case 'github':
        window.open('https://github.com/jdavidnel', '_blank');
        break;
      case 'home':
        window.location.href = 'http://localhost:8080/';
        break;
      default:
        break;
    }
  }

  public open() {
    this.visible = true;
  }

  public close() {
    this.visible = false;
    this.$emit('Window::Close', this.instance);
    // this.$destroy();
  }

  public reduce() {
    this.visible = false;
    this.$emit('Window::Reduce', this.instance);
  } */
}
